module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-12\">\r\n            <h1>Thank you for your interest!</h1>\r\n            <h2>We will review your request and get back to you shortly.</h2>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/account/registration-success/registration-success.html
// module id = 35
// module chunks = 0